"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SuperEventEmitter_1 = require("./SuperEventEmitter");
/**
 * Event container context encapsulates listeners.
 */
class EventContainerContext extends SuperEventEmitter_1.SuperEventEmitter {
    /**
     * Constructs the event container context.
     *
     * @param {Function} destroyer
     * @param {Function} emitter
     */
    constructor(destroyer, emitter) {
        super();
        this.destroyer = destroyer;
        this.emitter = emitter;
    }
    /**
     * Destroys the context remove all listeners.
     */
    destroy() {
        this.destroyer(this);
    }
    /**
     * @inheritDoc
     */
    emit(event, ...args) {
        return this.emitter(event, ...args);
    }
}
exports.default = EventContainerContext;
